export function timeSince(dateString, lang = "vi") {
  const seconds = Math.floor((new Date() - new Date(dateString)) / 1000);

  const intervals = [
    { key: "year",    sec: 31536000 },
    { key: "month",   sec: 2592000 },
    { key: "day",     sec: 86400 },
    { key: "hour",    sec: 3600 },
    { key: "minute",  sec: 60 },
  ];

  for (let i of intervals) {
    const value = Math.floor(seconds / i.sec);
    if (value >= 1) {
      return lang === "vi"
        ? `${value} ${translateUnit(i.key, value, lang)} trước`
        : `${value} ${translateUnit(i.key, value, lang)} ago`;
    }
  }

  return lang === "vi" ? "Vừa cập nhật" : "Just updated";
}

function translateUnit(unit, value, lang) {
  const en = {
    year: "year",
    month: "month",
    day: "day",
    hour: "hour",
    minute: "minute",
  };

  const vi = {
    year: "năm",
    month: "tháng",
    day: "ngày",
    hour: "giờ",
    minute: "phút",
  };

  return lang === "vi"
    ? vi[unit]
    : value > 1
    ? en[unit] + "s"
    : en[unit];
}
